import React from 'react'
import Scroll from "../../Components/ScrollToTop"
import Banner from "../../Components/Banner/ContactUs"
import Main from "../../Components/ContactUs/ContactUs"

function ContactUs() {
  return (
    <div>
        <Scroll/>
        <Banner/>
        <Main/>
      
    </div>
  )
}

export default ContactUs
